import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import RemainingLandingContent from './RemainingLandingContent';

const WhatsappApiForAgencies = () => (
  <>
    <Helmet>
      <title>WhatsApp API for Agencies &amp; Client Messaging | HAWKTRION</title>
      <meta name="description" content="Manage WhatsApp campaigns, templates, automation, and integrations for agency clients with HAWKTRION. Build repeatable client messaging workflows." />
      <meta name="keywords" content="WhatsApp API for agencies, WhatsApp agency platform, client WhatsApp messaging" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-api-for-agencies/" />
      <meta property="og:title" content="WhatsApp API for Agencies &amp; Client Messaging | HAWKTRION" />
      <meta property="og:description" content="Manage WhatsApp campaigns, templates, automation, and integrations for agency clients with HAWKTRION. Build repeatable client messaging workflows." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-api-for-agencies/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp API for Agencies &amp; Client Messaging | HAWKTRION" />
      <meta name="twitter:description" content="Manage WhatsApp campaigns, templates, automation, and integrations for agency clients with HAWKTRION. Build repeatable client messaging workflows." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp API for Agencies and Client Messaging" hideCta>
      <RemainingLandingContent pageKey="agencies" />
    </SeoLandingPage>
  </>
);

export default WhatsappApiForAgencies;